import React, { memo } from 'react';
import PropTypes from 'prop-types';
import DistanceFromLocationLabel from '../../DistanceFromLocationLabel';

const DistancesToHotel = ({
  distanceToPort,
  distanceToAddress,
  geoName,
  walkingDistance,
}) => {
  const isEqual = distanceToAddress === distanceToPort;
  return (
    <div className="text-sm -ml-1 flex flex-wrap gap-x-1">
      {distanceToPort && !isEqual && <DistanceFromLocationLabel distance={distanceToPort} label="port" parentClassName="text-smallerHeading font-smallerHeading" />}
      <DistanceFromLocationLabel distance={distanceToAddress} walkingDistance={walkingDistance} parentClassName="text-smallerHeading font-smallerHeading" label={geoName + (isEqual ? ' port' : '')} />
    </div>
  );
};

DistancesToHotel.defaultProps = {
  distanceToPort: null,
  distanceToAddress: null,
  geoName: '',
  walkingDistance: null,
};

DistancesToHotel.propTypes = {
  distanceToPort: PropTypes.number,
  distanceToAddress: PropTypes.number,
  geoName: PropTypes.string,
  walkingDistance: PropTypes.number,
};

export default memo(DistancesToHotel);
